import { useMemo } from 'react';
import { useContent } from '../redux/reducer/content';
import { taskContent } from '../constants/copyright';
import { extensionUids } from '../constants/task';
import { isNumber } from 'lodash';
import { challengeTaskUid } from '../constants/shared/ids/challengeTaskUid';

const { formattedTasksDefault } = taskContent;

export const useFormattedTasks = () => {
  const { quests } = useContent();

  return useMemo(() => {
    if (!quests) return;

    return quests?.reduce((acc, quest, _, arr) => {
      const { previousQuestId } = quest;

      if (quest.uid === challengeTaskUid) return acc;

      if (isNumber(previousQuestId)) {
        const prevQuest = arr.find(({ qid }) => qid === previousQuestId);
        if (!prevQuest?.isCollected) return acc;
      }

      const changeField =
        [
          { key: 'extension', condition: extensionUids.includes(quest.uid) },
          { key: 'special', condition: quest?.isSpecial },
          { key: 'weekly', condition: quest?.isWeekly && !quest.uid.startsWith('general') },
          { key: 'daily', condition: quest?.isDaily },
        ].find(({ key, condition }) => condition)?.key ?? 'others';

      if (changeField === 'extension') return acc;

      const { title, list, completed, fresh, order } = acc[changeField];

      const updatedList = [...list, quest]
        .sort((a, b) => a.isCollected - b.isCollected || a.isComplete - b.isComplete)
        .sort((a, b) => {
          if (a.isEvent && !b.isEvent) return -1;
          if (!a.isEvent && b.isEvent) return 1;
          return 0;
        });

      return {
        ...acc,
        [changeField]: {
          title,
          order,
          list: updatedList,
          completed: completed + +quest.isComplete,
          fresh: fresh + +quest.isNew,
        },
      };
    }, formattedTasksDefault);
  }, [quests]);
};
